import EditIcon from "@mui/icons-material/EditOutlined";
import { IconButton } from "@mui/material";
import { useAuthorizer } from "@styleguide";
import type { Dispatch, SetStateAction } from "react";
import { CandidateObjectiveLoadingState } from "../index";

export interface IPaperCandidateObjectiveButtonEditProps {
  setCollapsed: Dispatch<SetStateAction<boolean>>;
  disabled?: boolean;
  loading: CandidateObjectiveLoadingState;
}

export const PaperCandidateObjectiveButtonEdit = ({
  setCollapsed,
  disabled,
  loading,
}: IPaperCandidateObjectiveButtonEditProps) => {
  const authorized = useAuthorizer(["candidate.challenges.modify"]);

  const toggleCollapse = () => {
    setCollapsed((collapsed) => !collapsed);
  };

  return (
    <IconButton
      color="primary"
      onClick={toggleCollapse}
      disabled={!authorized || disabled || loading !== CandidateObjectiveLoadingState.NONE}
    >
      <EditIcon />
    </IconButton>
  );
};
